import { IMAGES } from "@/data";

const GALLERY = [
  { src: IMAGES.realWork, alt: "ClearCo tech cleaning windows on a ladder", span: "md:row-span-2", h: "h-full min-h-[420px]" },
  { src: IMAGES.realClose, alt: "ClearCo technician detailing a window", span: "", h: "h-52" },
  { src: IMAGES.realPortrait, alt: "ClearCo team member on the job", span: "", h: "h-52" },
  { src: IMAGES.commercial, alt: "Clean commercial glass building", span: "", h: "h-52" },
  { src: IMAGES.solar, alt: "Freshly cleaned solar panels", span: "", h: "h-52" },
];

export const Gallery = () => {
  return (
    <section id="gallery" className="py-24 bg-ink">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <p className="uppercase tracking-[0.2em] text-sm font-semibold text-brand">Our work</p>
          <h2 className="mt-3 font-display font-bold text-4xl md:text-5xl tracking-tight text-white">
            Real results, real shine
          </h2>
          <p className="mt-4 text-lg text-slate-400 leading-relaxed">
            A look at the crystal-clear finish we bring to homes and businesses across the Front Range.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 gap-4 auto-rows-auto">
          {GALLERY.map((g, i) => (
            <div
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden rounded-2xl border border-white/10 ${g.span} ${i === 0 ? "row-span-2 col-span-2 md:col-span-1" : ""}`}
            >
              <img
                src={g.src}
                alt={g.alt}
                className={`w-full ${g.h} object-cover transition-transform duration-500 group-hover:scale-105`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
